import axios from "axios";
import { config } from '../config.env'

const platform = config.PLATFORM;
const endpoint = config.ENDPOINT;

export function lookupHospitalList() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/lookup/hospital`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function lookupDoctorList() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/lookup/doctor`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}